var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid:menu-alt-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.79998C0 4.48172 0.171581 4.17649 0.476997 3.95145C0.782414 3.7264 1.19665 3.59998 1.62857 3.59998H21.1714C21.6034 3.59998 22.0176 3.7264 22.323 3.95145C22.6284 4.17649 22.8 4.48172 22.8 4.79998C22.8 5.11824 22.6284 5.42346 22.323 5.6485C22.0176 5.87355 21.6034 5.99998 21.1714 5.99998H1.62857C1.19665 5.99998 0.782414 5.87355 0.476997 5.6485C0.171581 5.42346 0 5.11824 0 4.79998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 11.6817 0.0980463 11.3765 0.27257 11.1515C0.447094 10.9264 0.683798 10.8 0.930612 10.8H12.098C12.3448 10.8 12.5815 10.9264 12.756 11.1515C12.9305 11.3765 13.0286 11.6817 13.0286 12C13.0286 12.3182 12.9305 12.6235 12.756 12.8485C12.5815 13.0736 12.3448 13.2 12.098 13.2H0.930612C0.683798 13.2 0.447094 13.0736 0.27257 12.8485C0.0980463 12.6235 0 12.3182 0 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.2C0 18.8817 0.128686 18.5765 0.357748 18.3515C0.58681 18.1264 0.897485 18 1.22143 18H8.55C8.87394 18 9.18462 18.1264 9.41368 18.3515C9.64274 18.5765 9.77143 18.8817 9.77143 19.2C9.77143 19.5183 9.64274 19.8235 9.41368 20.0485C9.18462 20.2736 8.87394 20.4 8.55 20.4H1.22143C0.897485 20.4 0.58681 20.2736 0.357748 20.0485C0.128686 19.8235 0 19.5183 0 19.2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHam);
export default __webpack_public_path__ + "static/media/menu-ham.f89787e9e1ce4cd9e3a485b5e8c23b8e.svg";
export { ForwardRef as ReactComponent };